.ButtonSet {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  border-radius: 112.5px;
  padding: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.05em;
  @include themify($themes) {
    background-color: themed("background_secondary");
    color: themed("font_primary");
  }

  .item {
    padding: 6px 15px;
    border-radius: 24px;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    column-gap: 3px;
    transition: background-color 0.2s ease-in-out;
    justify-content: center;

    &:not(.disabled):hover {
      @include themify($themes) {
        background-color: rgba(themed("default_tab_background"), 0.5);
      }
    }

    &.disabled {
      cursor: default;
      opacity: 0.3;
    }

    &:hover {
      .lockedTooltip {
        opacity: 1;
        transition: opacity 0.25s ease-in;
      }
    }
  }

  .activeItem {
    padding: 6px 0;
    border-radius: 24px;
    color: transparent;
    position: absolute;
    top: 4px;
    transition: left 0.2s ease-in-out, width 0.2s ease-in-out;
    @include themify($themes) {
      background-color: themed("default_tab_background");
    }
  }
}

.locked {
  @include themify($themes) {
    color: themed("neutral-primary");
  }

  svg {
    height: 10px;
    width: 10px;
  }
}

.overflowCheck {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.lockedTooltipWrapper {
  white-space: break-spaces;
  display: flex;
  flex-direction: column;
  width: 260px;

  .lockedTooltipHeader {
    font-size: 16px;
    line-height: 22px;
  }

  .lockedTooltipText {
    margin-top: 6px;
    font-size: 14px;
  }

  .lockedTooltipSalesLink {
    color: #ffffff;
  }
}
